Vue.component('map-results-page', {
    props: ['results'],
    data() {
        return {
            currentTab: null,
        }
    },
    computed: {

    },
    methods: {
        scoreColor(score) {
            if (score <=5) {
                return null;
            }
            if (score > 5 && score <= 10) {
                return '#fdeed3';
            }
            if (score > 10 && score <= 20) {
                return '#fdeed3';
            }

            return '#fde0d5';
        },
        themeClass(impactDriver) {
            var classes = {};

            classes[impactDriver.icon_name] = true;

            return classes
        }
    },
    mounted() {
        this.currentTab = this.results[0];
    }
});